import { render, staticRenderFns } from "./items-modal.vue?vue&type=template&id=96126a32&scoped=true&"
import script from "./items-modal.vue?vue&type=script&lang=js&"
export * from "./items-modal.vue?vue&type=script&lang=js&"
import style0 from "./items-modal.vue?vue&type=style&index=0&id=96126a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96126a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96126a32')) {
      api.createRecord('96126a32', component.options)
    } else {
      api.reload('96126a32', component.options)
    }
    module.hot.accept("./items-modal.vue?vue&type=template&id=96126a32&scoped=true&", function () {
      api.rerender('96126a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/items-modal.vue"
export default component.exports